(function($) {
  $('.index-banner-slider').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    arrows: false,
    dots: true,
  });
  $('.index-car-slider').slick({
    arrows: false,
    dots: false,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 5000,
    adaptiveHeight: false,
    swipe: false,
  }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    // console.log(currentSlide, nextSlide, nextSlide - currentSlide < 0);
    // if (nextSlide - currentSlide < 0) {
    //   slick.$slider.addClass('wheel-run-rev');
    // } else {
    //   slick.$slider.addClass('wheel-run');
    // }
    slick.$slider.addClass('wheel-run');
  }).on('afterChange', function(event, slick, currentSlide, nextSlide){
    slick.$slider.removeClass('wheel-run wheel-run-rev');
  });
  $('.index-news-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      },
    ],
  });
  $('.index-client-slider').slick({
    arrows: true,
    dots: false,
    adaptiveHeight: true,
  });
})($);